import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';
import * as styles from './EmptyNewbuildingsBanner.css';
import logo from './assets/call-me-hand.svg';

export function EmptyNewbuildingsBanner() {
  return (
    <article className={styles['container']}>
      <div className={styles['logo']}>
        <img src={logo} alt="Поиск не дал результатов" width={40} height={40} />
      </div>
      <div className={styles['title']}>
        <ArticleHeading4>Нет подходящих жилых комплексов</ArticleHeading4>
      </div>

      <ArticleParagraph2 color="gray60_100">Попробуйте изменить параметры в фильтрах</ArticleParagraph2>
    </article>
  );
}
